<mat-card>
  <form name="channelsForm" [formGroup]="form">
    <h3>Further information about your event</h3>
    <p>How can people find out more about your event?</p>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput required formControlName="website" name="event_website" type="url" aria-label="Contact Page"
            (focusout)="prepareUrl($event,'website')">
          <mat-label>Link</mat-label>
          <mat-hint>Does this event have a website, Facebook page, twitter page, Instagram page? Please provide the preferred link.</mat-hint>
          <mat-error *ngIf="form.get('website').invalid">{{getErrorMessage('website')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">

      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <input matInput formControlName="phone" name="contacts_phonenumber" aria-label="Phone Number" type="tel"
            (focusout)="trimValue($event,'phone', 'phone')" (focus)="prefillphone($event,'phone')">
          <mat-label>Phone Number</mat-label>
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>Phone number for people to contact regarding this event.</mat-hint>
          <mat-error *ngIf="form.get('phone').invalid">{{getErrorMessage('phone')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput formControlName="twitter" type="url" name="event_twitter" aria-label="Twitter Address" (focusout)="trimValue($event,'twitter')">
          <mat-label>Twitter</mat-label>
          <mat-hint>Is the event on Twitter?</mat-hint>
          <mat-error *ngIf="form.get('twitter').invalid">{{getErrorMessage('twitter')}}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput class="facebook" formControlName="facebook"  type="url" name="event_facebook" aria-label="Facebook Address" (focusout)="trimValue($event,'facebook')">
          <mat-label>Facebook</mat-label>
          <mat-hint>Is the event on Facebook?</mat-hint>
          <mat-error *ngIf="form.get('facebook').invalid">{{getErrorMessage('facebook')}}</mat-error>
        </mat-form-field>
      </div>
    </div> -->

    <!-- <div class="row youtube-notice">
      <div class="col-12">
        <p>*You can specify YouTube videos in Step 5</p>
      </div>
    </div> -->
  </form>
</mat-card>